import React from "react";

export const Card = ({ title, rightContent, children }) => {
    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="mb-1 mt-1">{title}</h4>
                {rightContent}
            </div>
            <div className="card-body">
                {children}
            </div>
        </div>
    )
}

export const CardWithoutHead = ({ children }) => {
    return (
        <div style={{ height: "100vh" }} className="card">
            <div className="card-body">
                {children}
            </div>
        </div>
    )
}

